import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faVideo, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import styles from './styles.module.css';
import BBBResourceRightColumn from './BBBResourceRightColumn';
import { RecordItem } from './types';

interface OwnProps {
  closeBBBResourceMain: () => void;
  bbbResources: RecordItem[];
  isMobileDevice: boolean;
  isDarkMode: boolean;
}

interface State {
  selectedResource: RecordItem;
  bbbResourceRecords: RecordItem[];
}

class BBBResourceMain extends Component<OwnProps, State> {
  constructor(props: OwnProps) {
    super(props);
    this.state = {
      selectedResource: {
        id: props.bbbResources[0]?.id || '',
        bbbId: props.bbbResources[0]?.bbbId || '',
        contextualText: {
          description: props.bbbResources[0]?.contextualText?.description || '',
          subtitle: props.bbbResources[0]?.contextualText?.subtitle || '',
          tag: props.bbbResources[0]?.contextualText?.tag || '',
          title: props.bbbResources[0]?.contextualText?.title || '',
        },
        videoUrl: props.bbbResources[0]?.videoUrl || null,
        imageUrl: props.bbbResources[0]?.imageUrl || null,
        media: props.bbbResources[0]?.media || ('video' as const),
        title: props.bbbResources[0]?.title || '',
        status: props.bbbResources[0]?.status || '',
        timestamp: props.bbbResources[0]?.timestamp || 0,
      },
      bbbResourceRecords: props.bbbResources,
    };
  }

  static getIconForMedia(media: RecordItem['media']) {
    switch (media) {
      case 'video':
        return faVideo;
      case 'image':
        return faImage;
      case 'text':
      default:
        return faFileAlt;
    }
  }

  getResourceItemClassName(resource: RecordItem) {
    const { isDarkMode } = this.props;
    const { selectedResource } = this.state;

    const baseClass = styles.resourceItem;
    const darkModeClass = !isDarkMode ? styles.resourceItemDarkMode : '';
    const selectedClass = resource.id === selectedResource.id ? styles.selected : '';
    const selectedDarkClass =
      resource.id === selectedResource.id && !isDarkMode ? styles.selectedDarkMode : '';

    return `${baseClass} ${darkModeClass} ${selectedClass} ${selectedDarkClass}`.trim();
  }

  render() {
    const { selectedResource, bbbResourceRecords } = this.state;
    const { closeBBBResourceMain, isMobileDevice, isDarkMode } = this.props;

    return (
      <div className={`${styles.container} ${isMobileDevice && styles.containerMobile}`}>
        <button
          type="button"
          className={`${styles.closeButton} ${
            !isDarkMode && selectedResource.media !== 'video' && styles.closeButtonDarkMode
          } ${isMobileDevice && styles.closeButtonMobile}`}
          onClick={closeBBBResourceMain}
        >
          ✕
        </button>
        <div
          className={`${styles.columnsContainer} ${
            isMobileDevice && styles.mobileColumnsContainer
          }`}
          style={{
            height: isMobileDevice ? '' : '100%',
          }}
        >
          <div
            style={{
              borderRadius: isMobileDevice ? '0 0 0 0' : '10px 0 0 10px',
              textAlign: isMobileDevice ? 'center' : 'left',
              paddingTop: isMobileDevice ? '20px' : '',
              paddingBottom: isMobileDevice ? '20px' : '',
            }}
            className={`${styles.leftColumn} ${isDarkMode && styles.leftColumnDarkMode} ${
              !isMobileDevice && styles.leftColumnDesktop
            }`}
          >
            {isMobileDevice && (
              <select
                className={styles.resourceSelect}
                value={selectedResource.id}
                onChange={e => {
                  const selected = bbbResourceRecords.find(r => r.id === e.target.value);
                  if (selected) {
                    this.setState({ selectedResource: selected });
                  }
                }}
                style={{
                  fontSize: '20px',
                  outline: 'none',
                  padding: '10px',
                  borderRadius: '10px',
                }}
              >
                {bbbResourceRecords.map(resource => (
                  <option key={resource.id} value={resource.id} style={{ fontSize: '20px' }}>
                    {resource.title}
                  </option>
                ))}
              </select>
            )}
            {!isMobileDevice && (
              <div
                className={`${styles.resourceList} ${!isDarkMode && styles.resourceListDarkMode}`}
              >
                {bbbResourceRecords.map((resource, index) => (
                  <React.Fragment key={resource.id}>
                    {index > 0 && <hr className={styles.divider} />}
                    <button
                      type="button"
                      className={`${styles.resourceItem} ${
                        !isDarkMode && styles.resourceItemDarkMode
                      } ${
                        selectedResource.id === resource.id &&
                        this.getResourceItemClassName(resource)
                      }`}
                      onClick={() => this.setState({ selectedResource: resource })}
                      title={resource.title.length >= 25 ? resource.title : undefined}
                    >
                      <span className={styles.resourceIcon}>
                        <FontAwesomeIcon icon={BBBResourceMain.getIconForMedia(resource.media)} />
                      </span>
                      <span className={`${styles.resourceTitle}`}>
                        {resource.title.length > 30
                          ? `${resource.title.slice(0, 27)}...`
                          : resource.title}
                      </span>
                    </button>
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
          <div
            className={`${styles.rightColumnContainer} ${
              isDarkMode && styles.rightColumnContainerDarkMode
            } ${selectedResource.media === 'text' && styles.rightColumnContainerWithText} ${
              !isMobileDevice && styles.rightColumnContainerDesktop
            }`}
            style={{
              borderRadius: isMobileDevice ? '0 0 0 0' : '0 10px 10px 0',
              paddingTop: isMobileDevice && selectedResource.media === 'text' ? '25px' : '',
            }}
          >
            {selectedResource && (
              <BBBResourceRightColumn
                resource={selectedResource}
                isMobileDevice={isMobileDevice}
                isDarkMode={isDarkMode}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default BBBResourceMain;
